import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { DateField, Form, ModuleSearchField, NumberTextField, SearchSelectField, Utils } from 'app/main/components';
import { useModel, useSettings } from 'app/main/components/hooks';

interface ItemMerchPointsEditLineDialogProps {
	baseModel?: any;
	isAdd?: boolean;
	updateRefresh?: () => void;
}

export function showItemMerchPointsEditLineDialog(props: ItemMerchPointsEditLineDialogProps) {
	return openDialog({
		children: <ItemMerchPointsEditLineDialog {...props} />,
		fullWidth: true,
		maxWidth: 'sm',
		onClose: () => {}
	});
}

export function ItemMerchPointsEditLineDialog(props: ItemMerchPointsEditLineDialogProps) {
	const dispatch = useDispatch();
	const { settings, t } = useSettings('items_merchpoints');

	const baseModel = { itmp_uid: uuidv4(), ...(props.baseModel || {}) };
	const { model, sendChange, save } = useModel({ baseModel, settings, isEdit: true, isAdd: props.isAdd });

	const executeSave = () => {
		save({
			onSuccess: () => {
				dispatch(Utils.alertLocalizedMsg(t, 'ALERT_UPDATE_SUCCESS', 'success'));
				dispatch(closeDialog());
				props.updateRefresh?.();
			}
		});
	};

	return (
		<>
			<DialogTitle>
				{t(props.isAdd ? 'ITEMS_MERCHPOINTS_ADD_DIALOG_TITLE' : 'ITEMS_MERCHPOINTS_EDIT_DIALOG_TITLE')}
			</DialogTitle>
			<DialogContent>
				<Form id="itemsMerchPointsLinesAddDialog" onSubmit={executeSave}>
					<Grid container spacing={2}>
						{/* PARENT TABLE UID */}
						{/* {!props.hideParentTable ? (
							<Grid size={12}>
								<ModuleSearchField
									name="itmp_item_uid"
									label={t('DETAILS_COMMISSIONS_FIELD_PARENT_TABLE_UID')}
									module=""
									uid={model.itmp_item_uid}
									isEdit
									sendChange={sendChange}
									afterChange={newValue => {
										sendChange(
											'cmms_parent_table_title',
											model.cmms_parent_table === 'contracts'
												? newValue.cntr_title
												: newValue.ords_title
										);
									}}
									required
									validationError={t('ERROR_TEXT_REQUIRED')}
								/>
							</Grid>
						) : (
							<></>
						)} */}
						{/* DATE FROM */}
						<Grid size={{ sm: 6, xs: 12 }}>
							<DateField
								name="itmp_d_from"
								label={t('DETAILS_ITEMS_MERCHPOINTS_FIELD_DATE_FROM')}
								value={model.itmp_d_from}
								isEdit
								sendChange={sendChange}
								required
								validationError={t('ERROR_TEXT_REQUIRED')}
							/>
						</Grid>
						{/* DATE TO */}
						<Grid size={{ sm: 6, xs: 12 }}>
							<DateField
								name="itmp_d_to"
								label={t('DETAILS_ITEMS_MERCHPOINTS_FIELD_DATE_TO')}
								value={model.itmp_d_to}
								isEdit
								sendChange={sendChange}
							/>
						</Grid>
						{/* PRICING GROUP */}
						<Grid size={{ sm: 6, xs: 12 }}>
							<SearchSelectField
								name="itmp_pric_id"
								label={t('DETAILS_ITEMS_MERCHPOINTS_FIELD_PRICING_GROUP')}
								systable="pricinggroups"
								value={model.itmp_pric_id}
								isEdit
								sendChange={sendChange}
							/>
						</Grid>
						{/* POINTS PRICE */}
						<Grid size={{ sm: 6, xs: 12 }}>
							<NumberTextField
								name="itmp_points_price"
								label={t('DETAILS_ITEMS_MERCHPOINTS_FIELD_POINTS')}
								value={model.itmp_points_price}
								isEdit
								sendChange={sendChange}
								required
								validationError={t('ERROR_TEXT_REQUIRED')}
							/>
						</Grid>
					</Grid>
				</Form>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => dispatch(closeDialog())}>{t('DIALOG_ACTION_CANCEL')}</Button>
				<Button type="submit" form="itemsMerchPointsLinesAddDialog" color="secondary">
					{t('DIALOG_ACTION_SAVE')}
				</Button>
			</DialogActions>
		</>
	);
}
